// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1LVKB","content":"Consent_content__2a23Q","footer":"Consent_footer__2fAlw"};